import { Icon } from "@planningcenter/tapestry-react"
import PropTypes from "prop-types"

const Banner = ({ children, onActionClick = null }) => {
  const displayActionButton = onActionClick !== null

  return (
    <div className="alert error-alert stripe-notification-banner" role="status">
      <Icon name="general.exclamationTriangle" color="error-dark" className="mr-2" />
      <div className="f-1">{children}</div>
      {displayActionButton && (
        <button type="button" className="btn btn-solid delete" onClick={onActionClick}>
          Resolve
        </button>
      )}
    </div>
  )
}

Banner.propTypes = {
  children: PropTypes.node.isRequired,
  displayActionButton: PropTypes.bool,
  onActionClick: PropTypes.func
}

export default Banner
